module.exports = "pegasus/assets/blocks/column-4-tech.png";